import {
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  GET_USERS_FAILED,
  SET_SELECTED_USER,
} from './actionTypes';

const initialState = {
  data: [],
  page: 1,
  lastPage: 1,
  loading: false,
  error: null,
  search: '',
  sort: null,
  order: null,
  selectedUserId: null,
};

const reAssignTableReducer = (state = initialState, {
  type, error, data, meta, selectedUserId,
}) => {
  switch (type) {
    case GET_USERS_REQUEST:
      return { ...state, loading: true };
    case GET_USERS_SUCCESS:
      return {
        ...state,
        data: data.map((i) => ({ ...i, _selected: false })),
        search: meta.search,
        page: meta.page,
        lastPage: meta.last_page,
        perPage: meta.per_page,
        sort: meta.sort,
        order: meta.order,
        loading: false,
      };
    case GET_USERS_FAILED:
      return { ...state, loading: false, error };
    case SET_SELECTED_USER:
      return {
        ...state,
        selectedUserId,
        data: state.data.map((i) => ({ ...i, _selected: selectedUserId === i.id })),
        loading: false,
      };
    default:
      return state;
  }
};

export default reAssignTableReducer;
